export default "__VITE_ASSET__CRbEkn3l__"